// Web Worker 内部的代码
self.onmessage = function(event) {
  const keywordsStr = event.data.str
  const matchReg = new RegExp(
    keywordsStr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(" ", "|"),
    "i"
  )
  const arr = event.data.data
  const result = []
  arr.forEach((item) => {
    for (let index = 0; index < item.texts.length; index++) {
      if (matchReg.test(item.texts[index].value)) {
        const value = resultStr(item.texts[index].value, 45, keywordsStr)
        item.texts[index].value = value
        result.push({ path: item.path, ...item.texts[index] })
      }
    }
  })
  self.postMessage(result)
}

// 使输入的文字显示在中间
function resultStr(str, leng, value) {
  // str被搜索的字符串,leng 需要截取的长度 , value 需要显示的内容
  let result = ""
  let index = 0
  let strFlag = false
  while (index < str.length) {
    const sliceStr = str.slice(index, (index += leng))
    if (strFlag) {
      result = result + sliceStr
    } else if (sliceStr.includes(value)) {
      strFlag = true
      result = result + sliceStr
    }
  }
  const regExp = new RegExp(value, "g")
  result = result.replace(
    regExp,
    `<span style="background: #fff9c5;padding:0 2px;color:#000;">${value}</span>`
  )
  return str.length > leng ? "..." + result : result
}
